document.addEventListener('DOMContentLoaded', function () {
  initGallery();
  initVariantPicker();
});

function initGallery() {
  document.querySelectorAll('[data-fp-thumbs]').forEach(function (wrap) {
    var mainImg = wrap.closest('.fp-product__gallery').querySelector('[id^="fp-main-img-"]');
    wrap.querySelectorAll('[data-fp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        wrap.querySelectorAll('[data-fp-thumb]').forEach(function (t) { t.classList.remove('fp-active'); });
        thumb.classList.add('fp-active');
        if (mainImg) mainImg.src = thumb.getAttribute('data-full');
      });
    });
  });
}

function initVariantPicker() {
  document.querySelectorAll('[data-fp-product-form]').forEach(function (form) {
    var wrapper = form.closest('div[id^="shopify-section-"]') || form.closest('.fp-product') || document;
    var variantsScript = wrapper.querySelector('script[data-fp-variants]');
    if (!variantsScript) return;
    var variantsData;
    try { variantsData = JSON.parse(variantsScript.textContent); } catch (e) { return; }
    if (!variantsData) return;

    var optionGroups = form.querySelectorAll('[data-fp-option-index]');
    if (!optionGroups.length) return;

    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-fp-add-btn]');
    var addText = form.querySelector('[data-fp-add-text]');
    var priceCurrent = wrapper.querySelector('.fp-product__price-current');

    function currentSelection() {
      var sel = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.fp-product__pill.fp-active');
        sel.push(active ? active.getAttribute('data-fp-value') : null);
      });
      return sel;
    }

    function findVariant(sel) {
      return variantsData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }

    function updateAvailability() {
      var sel = currentSelection();
      optionGroups.forEach(function (group, idx) {
        group.querySelectorAll('.fp-product__pill').forEach(function (pill) {
          var testSel = sel.slice();
          testSel[idx] = pill.getAttribute('data-fp-value');
          var match = variantsData.some(function (v) {
            return v.available && v.options.every(function (opt, i) { return testSel[i] === null || opt === testSel[i]; });
          });
          pill.disabled = !match;
        });
      });
    }

    function applyVariant() {
      var sel = currentSelection();
      var variant = findVariant(sel);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceCurrent && variant.price !== undefined) {
        priceCurrent.textContent = formatMoney(variant.price);
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? addText.getAttribute('data-add') || addText.textContent : (addText.getAttribute('data-soldout') || 'Sold out');
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.fp-product__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          group.querySelectorAll('.fp-product__pill').forEach(function (p) { p.classList.remove('fp-active'); });
          pill.classList.add('fp-active');
          updateAvailability();
          applyVariant();
        });
      });
    });

    updateAvailability();
  });
}
